import { SelectChangeEvent } from '@mui/material';
import { ExpandableContentWrapper } from 'components';
import { FuturesChart } from 'components/home/FuturesChart';
import { ComboSymbol } from 'config/hiro';
import { LIVE_PRICES_SYMS } from 'config/canvasComponentCatalog';
import { CanvasContentId } from 'types/canvas';
import { HomeQuadrantTabId } from 'types';
import { CanvasGroupLinkButton } from 'components/canvas/groups';

interface CanvasFuturesChartProps {
  id: number;
  sym: string;
  onSymChange: (sym: string) => void;
}

const CanvasFuturesChart = ({
  id,
  sym,
  onSymChange,
}: CanvasFuturesChartProps) => {
  const handleSymChange = (event: SelectChangeEvent<string>) => {
    const sym = event.target.value;
    onSymChange(sym ?? ComboSymbol.ES_F);
  };

  return (
    <ExpandableContentWrapper type={HomeQuadrantTabId.LIVE_PRICES_CHART}>
      <FuturesChart
        selectedSym={sym ?? ComboSymbol.ES_F}
        symSelectorSettings={{
          value: sym,
          options: [...LIVE_PRICES_SYMS],
          onChange: handleSymChange,
        }}
        headerExtras={
          <CanvasGroupLinkButton
            componentId={id}
            contentId={CanvasContentId.LIVE_PRICES_CHART}
          />
        }
      />
    </ExpandableContentWrapper>
  );
};

export default CanvasFuturesChart;
